/* @ngInject */
function analyticsService (CONSTANTS, ConnectorWebService, Utils) {
  const service = {
    getDataGroups,
    getPageComponentsByPageId,
    getDataFramesByPageId,
    getDataFrameDataFromId,
    getDataFrameDataSpreadsheet,
    getDataPageSpreadsheet,
    getImageThumbnailUrl,
    getInsights,
    insertDefaultParamsToUrl,
    addParamsToUrl
  }

  return service

  function getDataGroups (version) {
    let url = CONSTANTS.URL_ANALYTICS_DATA_GROUPS

    if (version) {
      url = Utils.fnAddQueryToUrl(url, { version })
    }

    return ConnectorWebService.get(url)
  }

  function getPageComponentsByPageId (slug) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_DATA_PAGE_COMPONENTS, [slug])

    return ConnectorWebService.get(url)
  }

  function getDataFramesByPageId (slug, params) {
    const { showArchived } = params

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_DATA_FRAMES, [slug])

    if (showArchived) {
      url = Utils.fnAddQueryToUrl(url, { showArchived })
    }

    return ConnectorWebService.get(url)
  }

  function getDataFrameDataFromId (dataPageSlug, dataFrameId, params) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_DATA_FRAMES_DATA, [dataPageSlug, dataFrameId])

    const parsedParams = {
      ...params,
      calendar: null,
      allFilters: null
    }

    url = service.insertDefaultParamsToUrl(url, parsedParams)

    url = service.addParamsToUrl(url, parsedParams)

    return ConnectorWebService.get(url)
  }

  function getDataFrameDataSpreadsheet (dataPageSlug, dataFrameId, params) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_DATA_FRAMES_DATA_SPREADSHEET, [
      dataPageSlug,
      dataFrameId
    ])

    const parsedParams = {
      ...params,
      calendar: null,
      allFilters: null
    }

    url = service.insertDefaultParamsToUrl(url, parsedParams)

    url = service.addParamsToUrl(url, parsedParams)

    return ConnectorWebService.get(url)
  }

  function getDataPageSpreadsheet (dataPageSlug, params) {
    const { start, end } = params

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_DATA_PAGE_SPREADSHEET, [dataPageSlug])

    url = Utils.fnAddStartEndQueriesToUrl(url, { start, end })

    const otherParameters = {
      ...params,
      start: null,
      end: null,
      calendar: null,
      allFilters: null
    }

    url = service.addParamsToUrl(url, otherParameters)

    return ConnectorWebService.get(url)
  }

  function getImageThumbnailUrl (assetId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [assetId])
  }

  function getInsights (module = 'home', params = {}) {
    const { start, end, maxInsights, boardId } = params

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ANALYTICS_INSIGHTS, [module])

    url = Utils.fnAddStartEndQueriesToUrl(url, { start, end })

    if (maxInsights) {
      url = Utils.fnAddQueryToUrl(url, { maxInsights })
    }

    if (boardId) {
      url = Utils.fnAddQueryToUrl(url, { boardId })
    }

    return ConnectorWebService.get(url)
  }

  // Utils
  function insertDefaultParamsToUrl (url, params) {
    const { start, end, top, skip, $order, $sort } = params

    url = Utils.fnAddStartEndQueriesToUrl(url, { start, end })

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if ($order || $sort) {
      url = Utils.fnAddQueryToUrl(url, { $order, $sort })
    }

    return url
  }

  function addParamsToUrl (url, params) {
    const { start, end, top, skip, $order, $sort, ...restParams } = params

    Object.entries(restParams).forEach(([key, value]) => {
      if (value && !Array.isArray(value)) {
        url = Utils.fnAddQueryToUrl(url, { [key]: value })
      } else if (value?.length) {
        url = Utils.addQueryStringFromArray(url, key, value)
      }
    })

    return url
  }
}

export { analyticsService }
